import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { OFFER_ANCHOR } from '../data/config';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timer = setTimeout(hide, 5000);
    };
    const hide = () => {
      setVisible(false);
      timer = setTimeout(() => {
        setIndex(i => (i + 1) % recentBuyers.length);
        show();
      }, 8000);
    };
    timer = setTimeout(show, 4000);
    return () => clearTimeout(timer);
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-50 w-[250px] sm:bottom-4 sm:left-4" aria-live="polite" data-id="element-169" data-mp="1gwufeb0wwgi7">
      <AnimatePresence data-id="element-170" data-mp="117frg5fx9zsx">
        {visible && !dismissed && <motion.div key={buyer.name} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative" data-id="element-171" data-mp="114tj43l7jg9n">
            <a href={OFFER_ANCHOR} className="flex items-start gap-2.5 rounded-lg border border-gold/60 bg-white px-3 py-2.5 shadow-popup" data-id="element-172" data-mp="i9v08rpoqp55">
              <span className="mt-0.5 flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full bg-check" data-id="element-173" data-mp="s5erh0tb0znk">
                <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} aria-hidden data-id="element-174" data-mp="28mkifwkca196" />
              </span>
              <span className="min-w-0 leading-tight" data-id="element-175" data-mp="23npobygx8q9r">
                <span className="block font-heading text-[11px] font-extrabold uppercase text-navy" data-id="element-176" data-mp="2anjlrmvdglaz">{buyer.name}</span>
                <span className="block text-[10px] text-ink" data-id="element-177" data-mp="2fm38hphsi14e">{buyer.place}</span>
                <span className="mt-1 block text-[10.5px] font-semibold text-brand" data-id="element-178" data-mp="2ko2aauxvspz8">Just purchased AQUA CLASS HUB™</span>
                <span className="block font-heading text-[9.5px] font-extrabold uppercase text-goldDark" data-id="element-179" data-mp="2pl2gr6yn7uqv">
                  {buyer.minutes} minutes ago
                </span>
              </span>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border border-gold/60 bg-white text-navy" data-id="element-180" data-mp="1wv2ap4seobmf">
              <XIcon className="h-3 w-3" strokeWidth={3} data-id="element-181" data-mp="195hma6dhgm5r" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}